import { handleActions } from 'redux-actions';
import * as Actions from '../constants/actions';

const initialState: QuestionToValidationLink[] = [];

export default handleActions<QuestionToValidationLink[], any>({
  /* empty for now */
}, initialState);
